import axios from "axios";
import moment from "moment";
import { wpApi } from "../config";

export const getBeers = () => {
  return new Promise((resolve, reject) => {
    const oldBeers = localStorage.getItem("baileson.beers");
    const timestamp = localStorage.getItem("baileson.lastActive");
    // if there's already beers saved
    // and timestamp is expired
    if (oldBeers && timestamp > moment().unix()) {
      return resolve(JSON.parse(oldBeers));
    }

    axios
      .get(`${wpApi}/beers`)
      .then((res) => {
        localStorage.setItem("baileson.beers", JSON.stringify(res.data));
        localStorage.setItem(
          "baileson.lastActive",
          moment().add(10, "minutes").unix()
        );
        resolve(res.data);
      })
      .catch((err) => {
        console.error("error fetching beers", err);
        reject();
      });
  });
};

export const getBeerById = (id) => {
  return new Promise((resolve, reject) => {
    axios
      .get(`${wpApi}/beer/id/${id}`)
      .then((res) => {
        resolve(res.data);
      })
      .catch((err) => {
        console.error("error fetching a single beer", err);
        reject();
      });
  });
};

export const getBeerBySlug = (slug) => {
  return new Promise((resolve, reject) => {
    axios
      .get(`${wpApi}${slug}`)
      .then((res) => {
        resolve(res.data);
      })
      .catch((err) => {
        console.error("error fetching a single beer", err);
        reject();
      });
  });
};

export const getEvents = () => {
  return new Promise((resolve, reject) => {
    axios
      .get(`${wpApi}/events`)
      .then((res) => {
        localStorage.setItem("baileson.events", JSON.stringify(res.data));
        resolve(res.data);
      })
      .catch((err) => {
        console.error("error fetching events", err);
        reject();
      });
  });
};

export const getPageBySlug = (slug) => {
  return new Promise((resolve, reject) => {
    axios
      .get(`${wpApi}/page${slug}`)
      .then((res) => {
        resolve(res.data);
      })
      .catch((err) => {
        console.error("error fetching a single page", err);
        reject();
      });
  });
};

export const getBreweryHours = () => {
  return new Promise((resolve, reject) => {
    axios
      .get(`${wpApi}/hours`)
      .then((res) => {
        resolve(res.data);
      })
      .catch((err) => {
        console.error("error fetching a single page", err);
        reject();
      });
  });
};

// subscribes a user to mailchimp
// @params - { first: String, last: String, email: String  }
// @return - confirmation or error of submission
export const subscribeUser = (values) => {
  return new Promise((resolve, reject) => {
    axios
      .post(`${wpApi}/subscribe`, { ...values })
      .then((response) => {
        if (response.data.is_valid) {
          resolve(response.data);
        } else {
          reject();
        }
      })
      .catch((err) => {
        console.error("error subscribing users", err);
        reject();
      });
  });
};



// WEBPACK FOOTER //
// ./src/actions/index.js